import React from "react";
import "./index.css";

const Section = ({ section, renderedInUL }) => {
  const renderContent = (section) => {
    switch (section.type) {
      case "heading":
        if (
          section.level === 1 &&
          section.text_content.trim().toUpperCase() ===
          "STUDY PARTICIPANT INFORMATION SHEET"
        ) {
          return null; // Hide this specific heading
        }
        return React.createElement(
          `h${Math.min(section.level, 6)}`,
          { className: `heading heading-level-${section.level}` },
          section.text_content
        );
      case "para":
        return <p className="consent-paragraph">{section.text_content}</p>;
      case "note":
        return (
          <blockquote className="consent-note">
            {section.text_content}
          </blockquote>
        );
      case "list": {
        // Items whose text starts with "1.", "2." ... are sub-options of the
        // previous main item: render them as nested bullets, number stripped.
        const SUB_ITEM = /^\s*\d+\s*\.\s*/;
        const groups = [];
        section.sub_section.forEach((subSec) => {
          const isSub =
            subSec.type === "list_item" &&
            typeof subSec.text_content === "string" &&
            SUB_ITEM.test(subSec.text_content);
          if (isSub && groups.length) {
            groups[groups.length - 1].children.push(
              subSec.text_content.replace(SUB_ITEM, "")
            );
          } else {
            groups.push({ section: subSec, children: [] });
          }
        });
        return (
          <ul className="consent-list">
            {groups.map(({ section: subSec, children }, idx) =>
              children.length ? (
                <li key={idx} className="consent-list-item">
                  {subSec.text_content}
                  <ul className="consent-sub-list">
                    {children.map((text, i) => (
                      <li key={i} className="consent-list-item">
                        {text}
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <Section key={idx} renderedInUL={true} section={subSec} />
              )
            )}
          </ul>
        );
      }
      case "list_item":
        return renderedInUL ? (
          <li className="consent-list-item">{section.text_content}</li>
        ) : null;
      default:
        return null;
    }
  };

  return (
    <div className="section-container">
      {renderContent(section)}
      {section.sub_section &&
        section.sub_section.map((subSec, idx) => (
          <Section key={idx} section={subSec} />
        ))}
    </div>
  );
};

// Main Consent Component
const PatientConsent = ({ data }) => {
  return (
    <div id="consentForm">
      <Section section={data} />
    </div>
  );
};

export default PatientConsent;
